import * as types from '../mutation-types'

const state = {
  // Lendo os produtos selecionados de string para JSON de localStorage
  // main: JSON.parse(localStorage.getItem('produtosSelecionados')) || []
  main: [],
  valorAleatorio: 0,
}

const mutations = {
  [types.ATUALIZAR_PRODUTOS] (state, produtos) {
    /**
       * Atualiza lista de produtos selecionados e salva a lista como string em localStorage
       */
     state.main = produtos;
    //  localStorage.setItem('produtosSelecionados', JSON.stringify(produtos));
  },
  [types.LIMPAR_PRODUTOS] (state) {
    /**
       * Limpa a lista de produtos selecionados
       */
     state.main = [];
    //  localStorage.removeItem('produtosSelecionados');
  },
  [types.REMOVER_PRODUTO] (state, index) {
    /**
       * Remove produto da lista de produtos selecionados
       */
    //  let index = state.main.indexOf(produto);
     state.main.splice(index, 1);
    //  localStorage.setItem('produtosSelecionados', JSON.stringify(state.main));
  },
  [types.ADICIONAR_PRODUTO] (state, produto) {
    /**
       * Adiciona produto da lista de produtos selecionados
       */
     state.main.push(produto);
    //  localStorage.setItem('produtosSelecionados', JSON.stringify(state.main));
  },
  [types.EDITAR_PRODUTO] (state, item) {
    /**
       * Adiciona produto da lista de produtos selecionados
       */
     state.main[item.index] = item.produto;
    //  localStorage.setItem('produtosSelecionados', JSON.stringify(state.main));
  },
  [types.VALOR_ALEATORIO] (state) {
    /**
       * Adiciona produto da lista de produtos selecionados
       */
     state.valorAleatorio = parseInt(Math.random() * 1000);
    //  localStorage.setItem('produtosSelecionados', JSON.stringify(state.main));
  },

}

export default {
  state,
  mutations
}

